// extracted by mini-css-extract-plugin
export var icon = "_6b-1";
export var subtext = "_6b-0";